import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false
    },
    mutations: {
        setToken(state, v) {
            state.token = v;
            localStorage.setItem('logintoken', v);
        },
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", JSON.stringify(user));
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
            localStorage.removeItem('logintoken');
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js